import * as swcHelpers from '@swc/helpers';

const upperFirst = (value)=>{
    return value[0].toUpperCase() + value.slice(1);
};
const defaultLineItems = {
    leftLensSku: '',
    leftLensName: '',
    rightLensSku: '',
    rightLensName: ''
};
const convertAttributesToLineItems = ({ attributesState , bundleSku , name , sku , solutionSku , solutionName ,  })=>{
    const productType = 'contact-lens-bundle';
    const eyeSides = Object.keys(attributesState);
    const eyeAttributes = eyeSides.reduce((result, eyeSide)=>{
        const lensAttributes = attributesState[eyeSide];
        const attributeKeys = Object.keys(lensAttributes);
        const lineItems = attributeKeys.reduce((eyeSideResult, attribute)=>{
            const lensAttributeName = `${eyeSide}Lens${upperFirst(attribute)}`;
            const lensAttributeValue = lensAttributes[attribute];
            if (lensAttributeValue === undefined) {
                return eyeSideResult;
            }
            // Some values can be "- 5.25", parseFloat needs "-5.25"
            const cleanValue = lensAttributeValue.replace(/\s+/g, '');
            return swcHelpers.objectSpread({}, eyeSideResult, {
                [lensAttributeName]: parseFloat(cleanValue)
            });
        }, {});
        return swcHelpers.objectSpread({}, result, lineItems, {
            [`${eyeSide}LensSku`]: sku,
            [`${eyeSide}LensName`]: name
        });
    }, defaultLineItems);
    // Remove undefined or empty string values
    const customAttributes = Object.entries(swcHelpers.objectSpread({}, eyeAttributes, {
        solutionSku,
        solutionName,
        type: productType
    })).reduce((result, [key, value])=>value == null || value === '' ? result : swcHelpers.objectSpread({}, result, {
            [key]: value
        })
    , {});
    return [
        {
            sku: bundleSku,
            customAttributes
        }
    ];
};

export { convertAttributesToLineItems };
//# sourceMappingURL=utils.js.map
